import { normalRequestProxy } from '../../lib/request-proxy.mjs';

class Component {
  onCreate(input) {
    const { error, nextTo } = input;
    this.state = {
      error,
      nextTo,
      isLoading: false,
    };
    this.notification = null;
    this.form = null;
  }

  onMount() {
    this.notification = this.getComponent('notification');
    this.form = this.getEl('form');

    this.notifyError();
  }

  notifyError() {
    const { error } = this.state;
    if (error) {
      this.notification.onError(error);
    }
  }

  reset() {
    this.setState('isLoading', false);
    this.form.reset();
  }

  async handleReset(data) {
    const { nextTo } = this.state;

    try {
      const proxy = normalRequestProxy();

      const url = new URL('/auth/forgot', window.location.origin);
      if (nextTo) {
        url.searchParams.set('next', nextTo);
      }
      const response = await proxy.post({
        path: url.href,
        data,
      });
      if (response) {
        this.notification.notify(response);
        return;
      }
    } catch (ex) {
      this.notification.onError(ex);
    } finally {
      this.reset();
    }
  }

  async onForgotFormSubmit(event, form) {
    event.preventDefault();
    event.stopPropagation();

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const data = new window.FormData(form);

    setTimeout(() => {
      this.setState('isLoading', true);
    }, 0);

    await this.handleReset(data);
  }
}

export default Component;
